import React, {
  createContext,
  Dispatch,
  useContext,
  useEffect,
  useReducer,
} from "react"

const initState: ChatInfoState = {
  isSearchBarEnabled: false,
  isChatLock: false,
  chatMenu: "USER",
  hasNewMessage: false,
}

const chatInfoContext = createContext<ChatInfoState>(initState)
const setChatInfoContext = createContext<Dispatch<ChatAction>>(() => {})

interface Props {
  children: React.ReactNode
}

function ChatProvider({ children }: Props) {
  const [chatInfoState, setChatInfo] = useReducer(chatReducer, initState)

  useEffect(() => {
    setChatInfo({
      type: "CHANGE_CHAT_LOCK",
      isChatLock: chatInfoState.isSearchBarEnabled,
    })
  }, [chatInfoState.isSearchBarEnabled])

  return (
    <chatInfoContext.Provider value={chatInfoState}>
      <setChatInfoContext.Provider value={setChatInfo}>
        {children}
      </setChatInfoContext.Provider>
    </chatInfoContext.Provider>
  )
}

function useChatInfo() {
  return useContext(chatInfoContext)
}

function useSetChatInfo() {
  return useContext(setChatInfoContext)
}

export { ChatProvider, useChatInfo, useSetChatInfo }

function chatReducer(state: ChatInfoState, action: ChatAction): ChatInfoState {
  switch (action.type) {
    case "TOGGLE_SEARCH_BAR":
      return {
        ...state,
        isSearchBarEnabled: !state.isSearchBarEnabled,
        isChatLock: !state.isSearchBarEnabled,
      }
    case "CHANGE_CHAT_LOCK":
      return {
        ...state,
        isChatLock: action.isChatLock ? action.isChatLock : false,
      }
    case "CHANGE_CHAT_GROUP":
      return {
        ...state,
        chatMenu: action.chatMenu ? action.chatMenu : "USER",
        isChatLock: false,
      }
    case "CHANGE_HAS_NEW_MESSAGE":
      return {
        ...state,
        hasNewMessage: action.hasNewMessage ? action.hasNewMessage : false,
      }
    case "CHANGE_MENU_STATE":
      return {
        ...state,
        chatMenu: action.chatMenu ? action.chatMenu : "USER",
        hasNewMessage: false,
        isChatLock: false,
      }
    default:
      throw new Error()
  }
}

interface ChatInfoState {
  isSearchBarEnabled: boolean
  isChatLock: boolean
  chatMenu: ChatMenu
  hasNewMessage: boolean
}

export interface ChatAction {
  type: ChatActionType
  isChatLock?: boolean
  chatMenu?: ChatMenu
  hasNewMessage?: boolean
}

export type ChatActionType =
  | "TOGGLE_SEARCH_BAR"
  | "CHANGE_CHAT_LOCK"
  | "CHANGE_CHAT_GROUP" // Admin에서 사용하는 액션.(전체 메세지 <-> 매니저메세지)
  | "CHANGE_HAS_NEW_MESSAGE"
  | "CHANGE_MENU_STATE" // 사용자가 사용하는 액션.(파트너 메세지 메뉴 <-> 매매전략 메뉴)

export type ChatMenu = "USER" | "MANAGER" | "TRADER" | "PARTNER"
